
import { defineComponent } from 'vue'

/**
 * Intermediary page where the integration installation happens
 */
export default defineComponent({
  name: 'IntegrationCallbackWrapper',

  props: {
    integrationLogo: {
      type: String,
      required: true
    },
    installingOn: {
      type: String,
      default: ''
    },
    isInstalling: {
      type: Boolean,
      required: true
    },
    primaryDisabled: {
      type: Boolean,
      required: true
    }
  },

  emits: ['trigger-install']
})
